<template>
    <div class="col-lg-4 m-auto">
        <card :title="$t(id ? 'edit_category' : 'add_category')" >
            <form @submit.prevent="saveUser" @keydown="form.onKeydown($event)">
                 <!-- Company -->
                <div class="form-group">
                    <label>{{ $t('company') }}</label>
                    <select v-model="form.company_id"
                        :class="{ 'is-invalid': form.errors.has('company_id') }"
                        class="form-control"
                        name="company" @change="fetchCategories">
                        <option value="" selected>{{ $t('select_company') }}</option>
                        <option v-bind:key="company.id" v-for="company in companies" v-bind:value="company.id">
                            {{ company.name }}
                        </option>
                    </select>
                    <has-error :form="form"
                        field="company_id" />
                </div>

                <!-- Name -->
                <div class="form-group">
                    <label>{{ $t('name') }}</label>
                    <input v-model="form.name"
                        :class="{ 'is-invalid': form.errors.has('name') }"
                        class="form-control"
                        type="text"
                        name="name">
                    <has-error :form="form"
                        field="name" />
                </div>

                <!-- Parent -->
                <div class="form-group">
                    <label>{{ $t('subcategory_for') }}</label>
                    <select v-model="form.parent_id"
                        class="form-control"
                        name="parent_id">
                        <option value="null" selected>Ingen</option>
                        <option value="null">-----------------------</option>
                        <option v-for="category in categories" :key="category.value" :value="category.value" v-html="category.label" />
                    </select>
                    <has-error :form="form"
                        field="category" />
                </div>

                
            </form>
            <div class="text-right" slot="footer">
                <button class="btn btn-primary" @click="saveCategory">{{ $t('send') }}</button>
            </div>
        </card>
    </div>
</template>
<script>
import $ from 'jquery'
import axios from "axios";
import Form from "vform";
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            loading: false,
            users: null,
            companies : null,
            categories : null,
            error: null,
            form: new Form({
                name: "",
                parent_id: null,
                company_id: "",
            })
        };
    },
    created() {
        this.form.company_id = this.$store.getters['auth/company'].id;
        this.fetchCategories(this.id);
        this.fetchData(this.id);
    },
    computed : {
        id(){
            return this.$route.params.id ? this.$route.params.id : false;
        }
    },
    methods: {
        userReset(){
            this.editUser = 0;
        },
        async fetchData(id) {
            //if(id) this.fetchUser(id);
            this.fetchCompany();
        },
        async fetchUser(id){
            const { data } = await axios.get("/api/user/" + id);
            
            this.form.name = data.name;
            this.form.email = data.email;
            this.form.company = data.company_id;
        },
        async fetchCategories(id){
            let { data } = await axios.get("/api/category?company_id=" + this.form.company_id);
            this.categories = data;

            this.fetchCategory(id);
        },
        async fetchCompany(id){
            console.log('fetch company');
            let { data } = await axios.get("/api/company")
            this.companies = data;
        },
        async saveCategory() {
            if(this.id){
                const { data } = await this.form.patch("/api/category/" + this.id);
                this.$router.go(-1);
            } else {
                const { data } = await this.form.post("/api/category");
                this.form.reset();
            }

            this.$store.dispatch('sidebar/fetchSidebar',this.$store.getters['auth/company'].id);
            
        },
        async fetchCategory(id){
            if(id){
                const { data } = await this.form.get("/api/category/" + this.id);
                console.log(data);
                this.populateForm(data);
            }
        },
        populateForm(data){

            for(var key in data) {
                if(this.form.hasOwnProperty(key)) {
                    this.form[key] = data[key];
                }
            }
        },
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/admin/categories/form.vue